import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, [location.pathname, location.key]);
    // location.key ensures it triggers even if pathname is same (like "/")

    return null;
};

export default ScrollToTop;
